<template>
    <b-carousel-slide>
        <b-container slot="img" class="container-lg pt-1 pb-2">
            <b-row>
                <b-col cols="12" md="6" class="centered-vertically">
                    <slot name="left"></slot>
                </b-col>
                <b-col cols="12" md="6" class="centered-vertically">
                    <slot name="right"></slot>
                </b-col>
            </b-row>
        </b-container>
    </b-carousel-slide>
</template>

<script>
    export default {
        name: `carousel-content-slide`
    }
</script>

<style lang="scss" scoped>
.centered-vertically {
    justify-content: center;
    display: flex;
    flex-direction: column;
    }
</style>
